import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminService} from '../../../shared/services/admin.service';
import {empty} from '../../../functions';
import {LocaleService} from '../../../shared/services/locale.service';
import {catchError} from 'rxjs/operators';
import bsCustomFileInput from 'bs-custom-file-input';
import {alertMessages, AlertService} from '../../../shared/services/alert.service';
import {ApiService} from '../../../shared/services/api.service';
import {educationSchoolTypes, EducationService} from '../../../shared/services/education.service';

@Component({
    selector: 'app-modal-admin-school',
    templateUrl: './modal-admin-school.component.html',
    styleUrls: ['./modal-admin-school.component.scss'],
    standalone: false
})
export class ModalAdminSchoolComponent implements OnInit {

  educationSchoolTypes = this.educationService.getSchoolTypeOptions();

  isProcessing = false;

  public data: any;

  entity = {
    id: '',
    name: '',
    schoolType: '',
    address: {
      street: '',
      number: '',
      numberSuffix: '',
      postalCode: '',
      city: '',
      country: '',
    },
    avatarUri: '',
    coverPhotoUri: ''
  };

  filePhotoUrl: any = '';
  filePhotoName = '';

  /**
   * Constructor
   *
   * @param activeModal
   * @param adminService
   * @param locale
   */
  constructor(public activeModal: NgbActiveModal,
              public adminService: AdminService,
              public locale: LocaleService,
              private alertService: AlertService,
              private api: ApiService,
              private educationService: EducationService) { }

  /**
   * Ng on init
   */
  ngOnInit(): void {

    this.entity = this.data.entity;

    // Ensure address object exists
    if (!this.entity.address) {
      this.entity.address = {
        street: '',
        number: '',
        numberSuffix: '',
        postalCode: '',
        city: '',
        country: '',
      };
    }

    bsCustomFileInput.init();


  }

  /**
   * Event handler when file input changes
   *
   * @param event
   */
  fileChangeEvent($event: any): void {
    // Search for file name when input file changes
    if ($event.target.files && $event.target.files.length > 0) {

      for (let i = 0; i < $event.target.files.length; i++) {
        const file = $event.target.files[i];
        this.filePhotoUrl = URL.createObjectURL(file);
        this.filePhotoName = file.name;
      }
    }
  }

  /**
   * Save
   *
   * @constructor
   */
  Save() {

    // Update
    if (!empty(this.entity.id)) {

      this.adminService.apiUpdateSchool(this.entity).pipe(catchError(this.adminService.handleError('apiUpdateSchool', false))).subscribe( (result) => {

        if (result !== false) {

          // Check for files to upload
          // Upload possible files
          const fileUploadPromises = {
            // Attachment promise
            imagePromise : new Promise((resolve, reject) => {

              if (this.filePhotoName) {
                // Create multipart form data of base64 and upload to correct API endpoint

                fetch(this.filePhotoUrl)
                  .then(res => res.blob())
                  .then(blob => {
                    const fd = new FormData();
                    const file = new File([blob], this.filePhotoName);
                    fd.append('file', file);

                    // Finally upload the file
                    const API_URL = this.api.getApiUrl() + '/school/' + this.entity.id + '/avatar' ;
                    const headers = this.api.getUploadHeaders();
                    fetch(API_URL, {method: 'PUT', headers: headers, body: fd})
                      .then((res) => {

                        this.isProcessing = false;

                        if (res.status == 200) {
                          resolve(true);

                        } else {
                          // Some error
                          resolve(false);
                        }


                      }).catch( (error) => {
                      this.isProcessing = false;
                    })

                  });

              }
              else {
                resolve(true);
              }

            })
          }; // File promises

          Promise.all([fileUploadPromises.imagePromise]).then( (values) => {

            // Check values and then close or warn

            if (values[0] === true) {
              this.alertService.success(alertMessages.successDataSaved);
              this.activeModal.close(true);
            } else {
              this.alertService.errorWithReport(new Error('school avatar upload failed'), 'adminSchool:updateAvatar');
            }

          });

        }

      });

    }
    // Create
    else {

      const { id, ...body } = this.entity;
      this.adminService.apiAddSchool(body).pipe(catchError(this.adminService.handleError('apiAddSchool', false))).subscribe( (result:any) => {

        if (result !== false) {

          // Newly created ID
          const schoolId = result['id'];

          // Check for files to upload
          // Upload possible files
          const fileUploadPromises = {
            // Attachment promise
            imagePromise : new Promise((resolve, reject) => {

              if (this.filePhotoName) {
                // Create multipart form data of base64 and upload to correct API endpoint

                fetch(this.filePhotoUrl)
                  .then(res => res.blob())
                  .then(blob => {
                    const fd = new FormData();
                    const file = new File([blob], this.filePhotoName);
                    fd.append('file', file);

                    // Finally upload the file
                    const API_URL = this.api.getApiUrl() + '/school/' + schoolId + '/avatar' ;
                    const headers = this.api.getUploadHeaders();
                    fetch(API_URL, {method: 'PUT', headers: headers, body: fd})
                      .then((res) => {

                        this.isProcessing = false;

                        if (res.status == 200) {
                          resolve(true);

                        } else {
                          // Some error
                          resolve(false);
                        }


                      }).catch( (error) => {
                      this.isProcessing = false;
                    })

                  });

              }
              else {
                resolve(true);
              }

            })
          }; // File promises

          Promise.all([fileUploadPromises.imagePromise]).then( (values) => {

            // Check values and then close or warn

            if (values[0] === true) {
              this.alertService.success(alertMessages.successDataSaved);
              this.activeModal.close(true);
            } else {
              this.alertService.errorWithReport(new Error('school avatar upload failed'), 'adminSchool:createAvatar');
            }

          });


        }

      });

    }
  }
}
